module.exports = __webpack_public_path__ + "img/singapore_24.4cad4c1b.png";